import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class RepresentanteLegalService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getHistorico(id: string | null, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/representantes-legais/${id}/historico?&page=${pageIndex}&sortDirection=desc`
    );
  }
}
